import { render, staticRenderFns } from "./purchase_storage_edit.vue?vue&type=template&id=17f2d028&scoped=true"
import script from "./purchase_storage_edit.vue?vue&type=script&lang=js"
export * from "./purchase_storage_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2d028",
  null
  
)

export default component.exports